// Foundations
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { AnalyticsService } from '@app/services/analytics.service';

// Models
import { PetStatus } from '@app/models/pet/pet-status.model';

@Component({
  selector: 'app-landing-dog',
  templateUrl: './landing-dog.component.html',
  styleUrls: ['./landing-dog.component.scss'],
})
export class LandingDogComponent implements OnInit {
  @Input() petTileList: PetStatus[];
  @Input() showReleaseError = false;

  constructor(private router: Router, private _analytics: AnalyticsService) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  navigateToDogProfileAdd() {
    this._analytics.logButtonTap('landing_addNewPet');

    this.router.navigate(['/camper-profile/add']);
  }
}
